// @flow

import AppDispatcher from 'PMT/flux/AppDispatcher';
import ActionTypes from 'constants/ActionTypes';
import Route from 'PMT/flux/Route';
import RoutingEnum from 'constants/RoutingEnum';

import RestaurantMenuTabs from "pages/menu/RestaurantMenuTabs";
import RouteStore from 'stores/RouteStore';

import { Menu, ProductOption, Product, ProductCategory, UpsellingCategory } from 'PMT/entities/menu';

export default class RouteAction {

  static redirectForce(route: Route, params: Object = null, query: Object = null) {
    RouteStore.redirectTo(
      route,
      params,
      query
    );
  }

  static redirectTo(route: Route, params: Object = null, query: Object = null) {
    RouteStore.redirectTo(route, params, query);
  }

  static redirectToFeatureNonActivated() {
    AppDispatcher.handleViewAction({
      type: ActionTypes.REDIRECT,
      route: RoutingEnum.FEATURE_NON_ACTIVATED
    });
  }

  static updateQueryParams(queryParams: Object) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.QUERY_PARAMS_UPDATE,
      queryParams
    });
  }

  //
  // Restaurant menu
  //

  static presentMenuDetail(menu: Menu) {
    const route = RoutingEnum.RESTAURANT_MENU_MENU_DETAIL;
    RouteStore.redirectTo(route, { menuId: menu.id });
  }

  static presentProductOptionDetail(productOption: ProductOption) {
    const route = RoutingEnum.RESTAURANT_MENU_PRODUCT_OPTION_DETAIL;
    RouteStore.redirectTo(route, { productOptionId: productOption.id });
  }

  static presentProductEdit(product: Product) {
    const route = RoutingEnum.RESTAURANT_MENU_PRODUCT_EDIT;
    RouteStore.redirectTo(route, { productId: product.id })
  }

  static presentCategoryDetail(category: ProductCategory) {
    const route = RoutingEnum.RESTAURANT_MENU_CATEGORY_DETAIL;
    RouteStore.redirectTo(route, { categoryId: category.id });
  }

  static presentMenusTab() {
    const route = RoutingEnum.RESTAURANT_MENU;
    RouteStore.redirectTo(route, {}, {tab: RestaurantMenuTabs.MENUS});
  }

  static presentProductsTab() {
    const route = RoutingEnum.RESTAURANT_MENU;
    RouteStore.redirectTo(route, {}, {tab: RestaurantMenuTabs.PRODUCTS});
  }

  static presentOptionsTab() {
    const route = RoutingEnum.RESTAURANT_MENU;
    RouteStore.redirectTo(route, {}, {tab: RestaurantMenuTabs.OPTIONS});
  }

  static presentCategoriesTab() {
    const route = RoutingEnum.RESTAURANT_MENU;
    RouteStore.redirectTo(route, {}, {tab: RestaurantMenuTabs.CATEGORIES});
  }

  static presentUpsellingCategoryDetail(upsellingCategory: UpsellingCategory) {
    const route = RoutingEnum.RESTAURANT_MENU_UPSELLING_CATEGORY_DETAIL;
    RouteStore.redirectTo(route, { upsellingCategoryId: upsellingCategory.id });
  }

}
